import React, { useState, useRef } from 'react';
import { Play, Pause, Volume2, VolumeX } from 'lucide-react';

const ProfileVideoPlayer = ({ videoUrl, className = "", autoPlay = false }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const [isMuted, setIsMuted] = useState(true); // Muted by default
  const [showControls, setShowControls] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div 
      className={`relative ${className}`}
      onMouseEnter={() => setShowControls(true)}
      onMouseLeave={() => setShowControls(false)}
    >
      <video
        ref={videoRef}
        src={videoUrl}
        className="w-full h-full object-cover rounded-lg"
        loop
        muted={isMuted}
        playsInline
        autoPlay={autoPlay}
        onClick={togglePlay}
        onEnded={() => setIsPlaying(false)}
      />
      
      {/* Video Controls Overlay */}
      <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${showControls ? 'opacity-100' : 'opacity-0'}`}>
        <div className="absolute inset-0 bg-black bg-opacity-20 rounded-lg"></div>
        
        {/* Center Play/Pause Button */}
        <button
          onClick={togglePlay}
          className="relative z-10 w-16 h-16 bg-white bg-opacity-90 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all shadow-lg"
        >
          {isPlaying ? (
            <Pause className="w-8 h-8 text-gray-800" />
          ) : (
            <Play className="w-8 h-8 text-gray-800 ml-1" />
          )}
        </button>
        
        {/* Mute/Unmute Button */}
        <button
          onClick={toggleMute}
          className="absolute bottom-4 right-4 z-10 w-10 h-10 bg-white bg-opacity-90 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all shadow-lg"
        >
          {isMuted ? (
            <VolumeX className="w-5 h-5 text-gray-800" />
          ) : (
            <Volume2 className="w-5 h-5 text-gray-800" />
          )}
        </button>
        
        {/* Video Badge */}
        <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-pink-500 to-purple-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
          📹 Profile Video
        </div>
      </div>
    </div>
  );
};

export default ProfileVideoPlayer;
